import { ICabecalhoResponse } from "../requests/types";

export default class Cabecalho {
  constructor(readonly response: ICabecalhoResponse | undefined) {}

  getSimplesNacional(): number {
    const response = this.response;

    if (!response) return 0;

    return response.regimesCounter.Simples || 0;
  }

  getLucroReal(): number {
    const response = this.response;

    if (!response) return 0;

    return response.regimesCounter.LucroReal || 0;
  }

  getLucroPresumido(): number {
    const response = this.response;

    if (!response) return 0;

    return response.regimesCounter.LucroPresumido || 0;
  }

  getSemCertificado(): number {
    const response = this.response;

    if (!response) return 0;

    return response.certificadosInvalidos;
  }
}
